import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { t } from 'i18next';
import '../../../scss/devicesConfiguration.scss';
import '../../../scss/colors.scss';
import noImageAvailable from '../../../assets/noImage_En.png';
import noImageAvailableSpanish from '../../../assets/noImage_Es.png';
import noImageAvailableFrench from '../../../assets/noImage_Fr.png';
import ChangeBackgroundModal from './Modals/ChangeBackgroundModal';
import {
    getDeviceConfiguration,
    getDownloadImageDeviceIdle,
    getDownloadImageDeviceManageClock,
} from '../../../Apis/backgroundChange';
import { useTranslation } from 'react-i18next';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import DividerWithText from "../../../components/DividerWithText";

const DevicesConfiguration = () => {
    const [deviceConfiguration, setDeviceConfiguration] = useState(null);
    const [deviceConfigurationIDLE, setDeviceConfigurationIDLE] = useState(null);
    const [deviceConfigurationTimeClock, setDeviceConfigurationTimeClock] = useState(null);
    const isPhotoInIdle = false;
    const isPhotoinTimeClock = false;
    const [open, setOpen] = useState(false);
    const [isIDLEBackgroundToChange, setIsIDLEBackgroundToChange] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [actualLanguage, setActualLanguage] = useState(null);
    const { i18n } = useTranslation();

    useEffect(() => {
        const currentLanguage = i18n.language;
        setActualLanguage(currentLanguage);
    }, [i18n.language]);

    useEffect(() => {
        const fetchDeviceConfigurationForIDLE = async () => {
            try {
                const response = await getDownloadImageDeviceIdle();
                if (response.status === 200) {
                    const reader = new FileReader();
                    reader.readAsDataURL(response.data);
                    reader.onloadend = function () {
                        const base64data = reader.result;
                        setDeviceConfigurationIDLE(base64data);
                    };
                } else {
                    console.error(t('something_went_wrong_2'), response.status);
                }
            } catch (error) {
                console.error(t('something_went_wrong_2'), error);
            }
        };
        const fetchDeviceConfigurationForTimeClock = async () => {
            try {
                const response = await getDownloadImageDeviceManageClock();
                if (response.status === 200) {
                    const reader = new FileReader();
                    reader.readAsDataURL(response.data);
                    reader.onloadend = function () {
                        const base64data = reader.result;
                        setDeviceConfigurationTimeClock(base64data);
                    };
                } else {
                    console.error(t('something_went_wrong_2'), response.status);
                }
            } catch (error) {
                console.error(t('something_went_wrong_2'), error);
            }
        };
        fetchDeviceConfigurationForIDLE();
        fetchDeviceConfigurationForTimeClock();
    }, []);

    useEffect(() => {
        const fetchDeviceConfiguration = async () => {
            try {
                const response = await getDeviceConfiguration();
                if (response.status === 200) {
                    setDeviceConfiguration(response.data);
                } else {
                    console.error(t('something_went_wrong_2'), response.status);
                }
            } catch (error) {
                console.error(t('something_went_wrong_2'), error);
            }
        };

        fetchDeviceConfiguration();
    }, []);

    const showChangeIDLEModal = () => {
        setIsIDLEBackgroundToChange(true);
        if (isIDLEBackgroundToChange) {
            handleOpen();
        }
    };

    const showChangeBackgroundTimeCLockModal = () => {
        setIsIDLEBackgroundToChange(false);
        if (isIDLEBackgroundToChange === false) {
            handleOpen();
        }
    };
    return (
        <Box className='complete--configuration--screen center-elements'>
            <HeadTittle name={'configuration'} link={routes.devices.list} />

            <Box>
                <DividerWithText title={t('background')} />
            </Box>
            <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-around'}
                className='section-configuration--background'
            >
                <Box className='idle-section--uploadImage centerElements halfScreen--sectionsDivider'>
                    <Typography variant='h1' color='initial' className='titles-h1--eachSection'>
                        {t('IDLE')}
                    </Typography>
                    <section className='photoSection centerElements'>
                        {deviceConfigurationIDLE ? (
                            <img className='img-width' src={deviceConfigurationIDLE} alt={t('background_for_IDLE')} />
                        ) : actualLanguage === 'en' ? (
                            <img src={noImageAvailable} className='img-width' alt={t('the_image_does_not_exist')} />
                        ) : actualLanguage === 'sp' ? (
                            <img
                                src={noImageAvailableSpanish}
                                className='img-width'
                                alt={t('the_image_does_not_exist')}
                            />
                        ) : (
                            <img
                                src={noImageAvailableFrench}
                                className='img-width'
                                alt={t('the_image_does_not_exist')}
                            />
                        )}
                    </section>

                    <p className='paragraph-to-changeImage' onClick={showChangeIDLEModal}>
                        {t('click_here_to_change_the_image').toUpperCase()}
                    </p>
                    <ChangeBackgroundModal
                        open={open}
                        handleClose={handleClose}
                        isIDLEBackgroundToChange={isIDLEBackgroundToChange}
                        isPhotoinTimeClock={isPhotoinTimeClock}
                        isPhotoInIdle={isPhotoInIdle}
                    />
                </Box>
                <Box className='section--timeClock centerElements halfScreen--sectionsDivider'>
                    <Typography variant='h1' color='initial' className='titles-h1--eachSection'>
                        {t('time_clock').toUpperCase()}
                    </Typography>
                    <section className='photoSection centerElements'>
                        {deviceConfigurationTimeClock ? (
                            <img
                                className='img-width'
                                src={deviceConfigurationTimeClock}
                                alt={t('background_for_time_clock')}
                            />
                        ) : actualLanguage === 'en' ? (
                            <img src={noImageAvailable} className='img-width' alt={t('the_image_does_not_exist')} />
                        ) : actualLanguage === 'sp' ? (
                            <img
                                src={noImageAvailableSpanish}
                                className='img-width'
                                alt={t('the_image_does_not_exist')}
                            />
                        ) : (
                            <img
                                src={noImageAvailableFrench}
                                className='img-width'
                                alt={t('the_image_does_not_exist')}
                            />
                        )}
                    </section>

                    <p className='paragraph-to-changeImage' onClick={showChangeBackgroundTimeCLockModal}>
                        {t('click_here_to_change_the_image').toUpperCase()}
                    </p>
                </Box>
            </Box>
        </Box>
    );
};

export default DevicesConfiguration;
